import { DispatchRepositoryInterface } from "@/data/persistences/repositories/contracts/DispatchRepositoryInterface";
import {
  DispatchListRequest,
  UpdateDispatch
} from "@/domain/entities/Dispatch";
import ApiService from "../../services/ApiService";
import { DispatchMapper } from "@/data/persistences/mappers/DispatchMapper";
import { DispatchEndpoint } from "../../endpoints/DispatchEndpoint";
import { UpdateDispatchRequestInterface } from "@/data/payload/contracts/DispatchRequest";
import {
  ProcessUpdateDispatchRequest,
  UpdateDispatchRequest
} from "@/data/payload/api/DispatchApiRequest";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";

export class DispatchApiRepository implements DispatchRepositoryInterface {
  private readonly service: ApiService;
  private readonly mapper: DispatchMapper;
  private readonly endpoints: DispatchEndpoint;

  constructor(
    service: ApiService,
    mapper: DispatchMapper,
    endpoints: DispatchEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async getList(params: DispatchListRequest) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getDispatchList(params)
    );

    return this.mapper.convertDispatchListFromApi(res);
  }

  async getDetail(id: number) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getDispatchDetail(id)
    );

    return this.mapper.convertDispatchDetailFromApi(res);
  }

  async updateDispatch(
    payload: UpdateDispatchRequestInterface
  ): Promise<UpdateDispatch> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.updateDispatch(),
      undefined,
      payload as UpdateDispatchRequest
    );
    return this.mapper.convertUpdateDispatchFromApi(resp);
  }

  async getListTemporary(params: ApiRequestList): Promise<ResponsePayloadV2> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getListTemporary(params)
    );

    return this.mapper.convertListTemporaryFromApi(res);
  }

  async processUpdateDispatch(
    payload: ProcessUpdateDispatchRequest
  ): Promise<ResponsePayloadV2> {
    const res = await this.service.invoke(
      "POST",
      this.endpoints.processUpdateDispatch(),
      undefined,
      payload as ProcessUpdateDispatchRequest
    );
    return this.mapper.convertProcessUpdateDispatchFromApi(res);
  }
}
